import { Button, TextField, Typography } from '@mui/joy';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { verifyUserOtp } from '../controllers/auth';
import Layout from '../Layout';
import { useDispatchContext, useStateContext } from '../Store/Context';
import NavBar from './WebPageComponents/NavBar';

const VerifyOtp = () => {

	const [otp, setOtp] = useState("");
	const [disabled, setDisabled] = useState(false);

	const dispatch = useDispatchContext();
	const {medium} = useStateContext();
	const navigate = useNavigate();

	async function handleOtpSubmit() {
		setDisabled(true);
		const isOtpCorrect = await verifyUserOtp(otp, dispatch);
		if (isOtpCorrect) {
			navigate("/");
		}
		setDisabled(false);
	}

	return (
		<>
			{medium==="web"&&<NavBar/>}
			<Layout>
				<div className='mb-4'>
					<Typography level='h4'>Verify OTP</Typography>
				</div>
				<div className='mb-4'>
					<div className='mb-2'>
						<TextField
							onChange={(e) => setOtp(e.target.value)}
							name="name"
							variant='soft'
							placeholder="Enter OTP here"
							label="OTP"
							value={otp}
						/>
					</div>
					<Button disabled={disabled} sx={{ mt: 1 /* margin top */ }} onClick={handleOtpSubmit}>Submit</Button>
				</div>
			</Layout>
		</>
  )
}

export default VerifyOtp;